(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayudha-pooja-landing"] && !Shopify.designMode) return;
  try {
    
  /*
    Product links work without JavaScript.
    JavaScript handles anchor scrolling and the optional mobile bar.
  */

  if (!customElements.get('mayon-campaign')) {
    class MayonCampaign extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;

        this._connected = true;
        this._frame = 0;

        this._start = () => {
          this._sticky = this.querySelector('[data-ma-sticky]');
          this._hero = this.querySelector('[data-ma-hero]');
          this._final = this.querySelector('[data-ma-final]');

          this._schedule = () => {
            if (this._frame) return;

            this._frame = requestAnimationFrame(() => {
              this._frame = 0;
              this._updateSticky();
            });
          };

          this._onClick = (event) => {
            if (
              event.defaultPrevented ||
              event.button !== 0 ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey
            ) {
              return;
            }

            const link = event.target.closest('a[data-ma-scroll]');

            if (!link || !this.contains(link)) return;

            const href = link.getAttribute('href') || '';

            if (!href.startsWith('#') || href.length < 2) return;

            const target = document.getElementById(href.slice(1));

            if (!target || !this.contains(target)) return;

            event.preventDefault();

            const reduce = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

            target.scrollIntoView({
              behavior: reduce ? 'auto' : 'smooth',
              block: 'start'
            });

            const heading = target.querySelector('h2');

            if (heading) {
              heading.setAttribute('tabindex', '-1');
              heading.focus({ preventScroll: true });

              heading.addEventListener(
                'blur',
                () => heading.removeAttribute('tabindex'),
                { once: true }
              );
            }
          };

          this.addEventListener('click', this._onClick);

          if (this._sticky) {
            window.addEventListener(
              'scroll',
              this._schedule,
              { passive: true }
            );

            window.addEventListener(
              'resize',
              this._schedule,
              { passive: true }
            );

            this._schedule();
          }
        };

        if (document.readyState === 'loading') {
          this._ready = this._start;

          document.addEventListener(
            'DOMContentLoaded',
            this._ready,
            { once: true }
          );
        } else {
          this._start();
        }
      }

      _updateSticky() {
        if (!this._sticky || !this.isConnected) return;

        const mobile = window.matchMedia(
          '(max-width: 749px)'
        ).matches;

        const bounds = this.getBoundingClientRect();

        const heroPassed = this._hero
          ? this._hero.getBoundingClientRect().bottom <= 0
          : bounds.top < -200;

        const endVisible =
          this._final &&
          this._final.getBoundingClientRect().top < window.innerHeight;

        this._sticky.hidden = !(
          mobile &&
          heroPassed &&
          bounds.bottom > 160 &&
          !endVisible
        );
      }

      disconnectedCallback() {
        this._connected = false;

        if (this._ready) {
          document.removeEventListener(
            'DOMContentLoaded',
            this._ready
          );
        }

        if (this._onClick) {
          this.removeEventListener('click', this._onClick);
        }

        if (this._schedule) {
          window.removeEventListener('scroll', this._schedule);
          window.removeEventListener('resize', this._schedule);
        }

        if (this._frame) {
          cancelAnimationFrame(this._frame);
        }

        this._frame = 0;
      }
    }

    customElements.define('mayon-campaign', MayonCampaign);
  }

  } catch(e) { console.error(e); }
})();
})();
